import { render } from "./Final.vue?vue&type=template&id=33d329c2&scoped=true"
import script from "./Final.vue?vue&type=script&lang=js"
export * from "./Final.vue?vue&type=script&lang=js"

import "./Final.vue?vue&type=style&index=0&id=33d329c2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d329c2"]])

export default __exports__